// Un champ de mot de passe avec l'œil qui se barre.
//
// Sur un téléphone, taper huit caractères à l'aveugle est la première cause
// d'abandon d'une inscription — et la deuxième d'un « mot de passe incorrect »
// qui n'en était pas un. L'œil règle les deux.
//
// L'ancienne version fabriquait cette enveloppe à la volée, en déplaçant le
// champ dans le document après coup (`brancherOeil`). Ici c'est un composant :
// le champ naît dans son enveloppe.

import { useState } from "react";
import Icone from "./Icone.jsx";

export default function ChampMotDePasse({ valeur, onChange, ...reste }) {
  const [montre, setMontre] = useState(false);

  return (
    <span className="champ-mdp">
      <input
        className="champ"
        type={montre ? "text" : "password"}
        value={valeur}
        onChange={(e) => onChange(e.target.value)}
        {...reste}
      />
      <button
        type="button"
        className="champ-mdp__oeil"
        aria-label={montre ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        onClick={() => setMontre((v) => !v)}
      >
        <Icone nom={montre ? "oeilBarre" : "oeil"} taille={19} />
      </button>
    </span>
  );
}
